import { useApiMaterialsV1MaterialRegionsRetrieve } from 'api';

import {
  AutocompleteField,
  type AutocompleteFieldProps,
  type AutocompleteOption,
} from '../AutocompleteField/AutocompleteField';

type Props = Omit<AutocompleteFieldProps<AutocompleteOption>, 'options'>;

export const RegionAutocompleteField = ({ name = 'region', required = false, label = 'Region', ...rest }: Props) => {
  const { data } = useApiMaterialsV1MaterialRegionsRetrieve();

  const options = data
    ? data.results.map((region) => ({
        label: region.name,
        value: region.id.toString(),
      }))
    : [];

  return <AutocompleteField label={label} name={name} required={required} options={options} {...rest} />;
};
